import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { debounce } from 'utils/common';



export default function useAssetFilter(pageSettings , setPageSettings) {
    const [searchParams, setSearchParams] = useSearchParams();
    

    const [filterLoading, setFilterLoading] = useState(false)
    const [isFilterDirty, setIsFilterDirty] = useState(false)
  const [filters, setFilters] = useState([
    {
        key: "search",
        label: "Search term",
        value: searchParams.get("search") || ""
    },
    {
        key: "issued_date_after",
        label: "Issued After",
        value: searchParams.get("issued_date_after") || ""
    },
    {
        key: "issued_date_before",
        label: "Issued Before",
        value: searchParams.get("issued_date_before") || ""
    },
    {
        key: "returned_date_before",
        label: "Returned Before",
        value: searchParams.get("returned_date_before") || ""
    },
    {
        key: "returned_date_after",
        label: "Returned After",
        value: searchParams.get("returned_date_after") || ""
    },
   
  ]);

  useEffect(()=>{      
    
        let _filters = [
            {
                key: "search",
                label: "Search term",
                value: searchParams.get("search") || ""
            },
            {
                key: "issued_date_after",
                label: "Issued After",
                value: searchParams.get("issued_date_after") || ""
            },
            {
                key: "issued_date_before",
                label: "Issued Before",
                value: searchParams.get("issued_date_before") || ""
            },
            {
                key: "returned_date_after",
                label: "Returned After",
                value: searchParams.get("returned_date_after") || ""
            },
            {
                key: "returned_date_before",
                label: "Returned Before",
                value: searchParams.get("returned_date_before") || ""
            }
            
          ]
          setFilters(_filters)
 

 
  },[])

  const handleFilterChange =  (data, key, make_call=false) => {
    console.log( "AAAA")

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = data?.label || ""
    selectedFilter['value'] = data?.value || ""
    setFilters(_filters)
    console.log( _filters, "AAAA")
    if(make_call){
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }


  };
  const handleInputChange = debounce((data, key, make_call=false) => {
    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)

    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){


        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }

  }, 1000)

  const handleDateChange = (data, key, make_call=false) => {
     let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){


        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }

  }

  // Clear All only resets the draft fields inside the drawer - it must
  // NOT trigger a search. The actual API call happens when the user
  // clicks Apply Filter.
  const handleClearAll = () => {
    const hadValues = filters.some(filter => filter.key !== "search" && (Array.isArray(filter.value) ? filter.value.length > 0 : !!filter.value))
    let clearedFilters = filters.map(filter => ({
      ...filter,
      value: Array.isArray(filter.value) ? [] : "",
      label: filter.key === "search" ? "Search term" : ""
    }))
    setFilters(clearedFilters)
    if(hadValues){
      setIsFilterDirty(true)
    }
  }

  return {
    handleFilterChange,
    filters,
    handleInputChange,
    filterLoading, setFilterLoading,
    handleDateChange,
    handleClearAll,
    isFilterDirty, setIsFilterDirty
  };
}
